'use client'

import { useEffect, useRef } from 'react'

export default function InteractiveBackground() {
  const backgroundRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!backgroundRef.current) return
      const { clientX, clientY } = e
      const x = (clientX / window.innerWidth) * 100
      const y = (clientY / window.innerHeight) * 100
      backgroundRef.current.style.setProperty('--mouse-x', `${x}%`)
      backgroundRef.current.style.setProperty('--mouse-y', `${y}%`)
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <div
      ref={backgroundRef}
      className="fixed top-0 left-0 right-0 bottom-0 pointer-events-none z-0 w-full h-full"
      style={{
        background: `
          radial-gradient(circle at var(--mouse-x, 50%) var(--mouse-y, 50%), rgba(79, 209, 197, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 20% 30%, rgba(79, 209, 197, 0.02) 0%, transparent 50%),
          radial-gradient(circle at 80% 70%, rgba(79, 209, 197, 0.02) 0%, transparent 50%)
        `,
      }}
    />
  )
}
